import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useAudioContentQuery, {
	type useAudioContentQuery$data,
	type useAudioContentQuery$variables,
} from './__generated__/useAudioContentQuery.graphql.ts';

export const preloadAudioContent = (
	contentId: string,
): Promise<{
	data: useAudioContentQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> => {
	return query<useAudioContentQuery$data, useAudioContentQuery$variables>({
		query: useAudioContentQuery,
		variables: {
			contentId,
		},
		fetchPolicy: 'network-only',
	});
};
